import React, { setGlobal, useEffect, useState } from "reactn";

import API from "../../api";
import Columns from "../../components/Columns";
import Container from "../../components/Container";
import Form from "../../components/Form";
import { Link } from "react-router-dom";
import Panel from "../../components/Panel";
import Section from "../../components/Section";
import Status from "../../components/Status";

const Contracts = ({ canCreate, canShowArchived }) => {
	useEffect(function () {
		(function () {
			setGlobal({ title: "Contracts" });
		})();
	}, []);

	const [contracts, setContracts] = useState(null);
	const [error, setError] = useState(null);
	const [showArchived, setShowArchived] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");

	useEffect(
		function () {
			(async function () {
				const query = showArchived ? {} : { archived: false };

				const { success, error, contracts } = await API.contracts.find(
					query
				);

				if (success) setContracts(contracts);
				else setError(error);
			})();
		},
		[showArchived]
	);

	// Filter contracts based on search query
	const filteredContracts =
		contracts?.filter((contract) => {
			if (!searchQuery) return true;

			const searchLower = searchQuery.toLowerCase();

			// Search in title
			if (contract.title?.toLowerCase().includes(searchLower))
				return true;

			// Search in site address
			if (contract.siteAddress?.toLowerCase().includes(searchLower))
				return true;

			// Search in client forename
			if (contract.client?.forename?.toLowerCase().includes(searchLower))
				return true;

			// Search in client surname
			if (contract.client?.surname?.toLowerCase().includes(searchLower))
				return true;

			// Search in client company
			if (contract.client?.company?.toLowerCase().includes(searchLower))
				return true;

			return false;
		}) || null;

	return (
		<Container>
			{canCreate && (
				<Link to={`/contract`}>
					<Panel>
						<Panel.Title>Initiate new contract</Panel.Title>
					</Panel>
				</Link>
			)}
			<Section title="Contracts">
				<Status error>{error}</Status>
				<Form.Input
					placeholder="Search contracts..."
					value={searchQuery}
					onChange={({ value }) => setSearchQuery(value)}
				/>
				{filteredContracts ? (
					<Columns>
						{filteredContracts.map(
							(
								{
									_id,
									title,
									siteAddress,
									records,
									completedRecordsCount,
									client,
								},
								index
							) => {
								const incomplete =
									records.length - completedRecordsCount;

								let clientInfo = client ? (
									<React.Fragment>
										{client.forename + " " + client.surname}
										{client.company ? (
											<i>, {client.company}</i>
										) : (
											""
										)}
									</React.Fragment>
								) : (
									<i>Missing client info</i>
								);

								return (
									<Panel key={index}>
										<Link to={`/contract/${_id}`}>
											{incomplete > 0 && (
												<Panel.Label variant="danger">
													{incomplete}
												</Panel.Label>
											)}
											<Panel.Title>
												{siteAddress || title}
											</Panel.Title>
											<Panel.Body>
												<p
													style={{
														margin: 0,
														fontWeight: "normal",
													}}
												>
													{clientInfo}
												</p>
											</Panel.Body>
										</Link>
									</Panel>
								);
							}
						)}
					</Columns>
				) : (
					<Status.Switch data={contracts} />
				)}
				{canShowArchived && (
					<p
						className="text-primary"
						style={{ textAlign: "center", cursor: "pointer" }}
						onClick={() => setShowArchived(!showArchived)}
					>
						{showArchived ? "Hide" : "Show"} archived contracts
					</p>
				)}
			</Section>
		</Container>
	);
};

export default Contracts;
